import { yupResolver } from '@hookform/resolvers/yup'
import React, { FC, useContext, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import { AuthContext } from '../../providers'
import { useUpdateCustomerDetailMutation } from '../../redux/api'
import { CustomerEntry } from '../../sdk'
import { loggingAssert } from '../../utils/handleError/loggingAssert'
import { EditableNotes, ErrorMessageWrapper } from '../SharedUI'
import { CUSTOMER_NOTES_VALIDATION } from './validation'

interface Props {
  customer: CustomerEntry
}
type FormValues = {
  notes: string
}

export const CustomerNotesForm: FC<Props> = ({ customer }) => {
  const [editing, setEditing] = useState(false)
  const [updateCustomerInfo, { error, isLoading }] =
    useUpdateCustomerDetailMutation()
  const { currentUser } = useContext(AuthContext)
  loggingAssert('No customer information', customer.information)
  const { handleSubmit, control } = useForm({
    mode: 'onBlur',
    defaultValues: {
      notes: customer.information!.notes || ''
    },
    resolver: yupResolver(CUSTOMER_NOTES_VALIDATION)
  })
  const submitHandler: SubmitHandler<FormValues> = async (data) => {
    await updateCustomerInfo({
      authorization: loggingAssert('Token not set', currentUser!.accessToken),
      customerEntry: {
        id: customer.id,
        information: {
          ...customer.information,
          notes: data.notes
        }
      }
    })
    setEditing(false)
  }
  return (
    <ErrorMessageWrapper errorMessage={error} loading={isLoading}>
      <form onSubmit={handleSubmit(submitHandler)}>
        <EditableNotes
          editing={editing}
          setEditing={setEditing}
          notes={customer.information!.notes as string}
          control={control}
        />
      </form>
    </ErrorMessageWrapper>
  )
}
